'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _rollupPluginBabelHelpers = require('../../../../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
var React__default = _interopDefault(React);
var PropTypes = _interopDefault(require('prop-types'));
var classNames = _interopDefault(require('classnames/dedupe'));
var Icon = require('../../01.atoms/Icon/Icon.js');
require('./_index.scss.js');

var CLASSNAME = 'varta-features-overlay',
    cnList = "".concat(CLASSNAME, "__list"),
    cnItem = "".concat(CLASSNAME, "__item"),
    cnText = "".concat(CLASSNAME, "__text"),
    cnTitle = "".concat(CLASSNAME, "__title"),
    cnIcon = "".concat(CLASSNAME, "__icon"),
    cnClose = "".concat(CLASSNAME, "__close");
/**
 * 
 */

var FeaturesOverlay = /*#__PURE__*/function (_React$Component) {
  _rollupPluginBabelHelpers.inherits(FeaturesOverlay, _React$Component);

  var _super = _rollupPluginBabelHelpers.createSuper(FeaturesOverlay);

  function FeaturesOverlay() {
    _rollupPluginBabelHelpers.classCallCheck(this, FeaturesOverlay);

    return _super.apply(this, arguments);
  }

  _rollupPluginBabelHelpers.createClass(FeaturesOverlay, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.timer);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          items = _this$props.items,
          onClose = _this$props.onClose;
      return /*#__PURE__*/React__default.createElement("div", {
        className: classNames(CLASSNAME, className)
      }, /*#__PURE__*/React__default.createElement("button", {
        className: cnClose,
        onClick: onClose
      }, /*#__PURE__*/React__default.createElement(Icon, {
        size: "sm",
        id: "times-small"
      })), /*#__PURE__*/React__default.createElement("ul", {
        className: cnList
      }, items.map(function (item, i) {
        return /*#__PURE__*/React__default.createElement("li", {
          key: i,
          className: cnItem
        }, /*#__PURE__*/React__default.createElement("img", {
          className: cnIcon,
          src: item.Icon
        }), /*#__PURE__*/React__default.createElement("h4", {
          className: cnTitle
        }, item.Title), /*#__PURE__*/React__default.createElement("div", {
          className: cnText
        }, item.Text));
      })));
    }
  }]);

  return FeaturesOverlay;
}(React__default.Component);
FeaturesOverlay.propTypes = {
  /** Additional class name */
  className: PropTypes.string,

  /** Array of items with title, icon, text */
  items: PropTypes.array.isRequired,

  /** Callback function */
  onClose: PropTypes.func.isRequired
};
FeaturesOverlay.defaultProps = {
  onClose: function onClose() {
    return void 0;
  },
  items: []
};

module.exports = FeaturesOverlay;
